import { Navigate, useLocation } from 'react-router-dom'
import { Spin } from 'antd'
import { useAuthStore } from '@features/auth'
import { impersonationService } from '@features/auth/services/impersonationService'
import { resolvePostLoginPath } from '@features/auth/utils/adminRedirect'

interface GuestRouteProps {
  children: React.ReactNode
}

function GuestRoute({ children }: GuestRouteProps) {
  const location = useLocation()
  const { isAuthenticated, user, isLoading } = useAuthStore()
  const from = (location.state as { from?: Location })?.from?.pathname || '/'

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    )
  }

  // Authenticated users without an organization still need the registration
  // page to finish the second step (organization details) after OAuth sign-up.
  if (isAuthenticated && (user?.organization_id || user?.role === 'super_admin')) {
    return (
      <Navigate
        to={resolvePostLoginPath(user?.role, impersonationService.isActive(), from)}
        replace
      />
    )
  }

  return <>{children}</>
}

export default GuestRoute
